<template>
    <b-input-group class="w-100">
        <b-form-input v-model="value"></b-form-input>
        <b-input-group-append>
            <b-form-datepicker v-model="value" button-only right locale="ru-RU" @context="value = $event.selectedYMD"></b-form-datepicker>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
    export default {
        name: "DatePicker",

        props: {
            value: {
                type: String,
                required: false,
                default: '',
            },
        },

        watch: {
            value: function (val, oldVal) {
                this.$emit('input', val);
            },
        },
    }
</script>

<style scoped>

</style>